import Modal from "./Modal";
import blue from '../../assets/blue.svg';
import red from '../../assets/red.svg';
import yellow from '../../assets/yellow.svg';
import green from '../../assets/green.svg';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { useRef } from "react";

function ColorPickModal({ onSelectColor }) {
    const colorsRef = useRef(null);

    useGSAP(() => {
        const distance = 6;

        gsap.fromTo(colorsRef.current.querySelectorAll('button:nth-child(1)'), {
            opacity: 0,
            y: -distance,
            x: -distance,
        }, {
            opacity: 1,
            y: 0,
            x: 0,
            duration: 0.333,
            ease: 'power1.out',
        })

        gsap.fromTo(colorsRef.current.querySelectorAll('button:nth-child(2)'), {
            opacity: 0,
            y: -distance,
            x: distance,
        }, {
            opacity: 1,
            y: 0,
            x: 0,
            duration: 0.333,
            ease: 'power1.out',
        })

        gsap.fromTo(colorsRef.current.querySelectorAll('button:nth-child(3)'), {
            opacity: 0,
            y: distance,
            x: -distance,
        }, {
            opacity: 1,
            y: 0,
            x: 0,
            duration: 0.333,
            ease: 'power1.out',
        })

        gsap.fromTo(colorsRef.current.querySelectorAll('button:nth-child(4)'), {
            opacity: 0,
            y: distance,
            x: distance,
        }, {
            opacity: 1,
            y: 0,
            x: 0,
            duration: 0.333,
            ease: 'power1.out',
        })
    }, [colorsRef]);

    return (
        <Modal>
            <div ref={colorsRef} className="grid grid-cols-2 gap-2 [&>button]:w-20">
                <button onClick={() => onSelectColor('blue')}><img src={blue} alt="blue" /></button>
                <button onClick={() => onSelectColor('red')}><img src={red} alt="red" /></button>
                <button onClick={() => onSelectColor('yellow')}><img src={yellow} alt="yellow" /></button>
                <button onClick={() => onSelectColor('green')}><img src={green} alt="green" /></button>
            </div>
        </Modal>
    )
}

export default ColorPickModal;